<template>
<div>
  <div class="country-top" v-if="countryInfo">
    <div :class="['country-info']">
      <country-top-country-info :countryInfo="countryInfo"></country-top-country-info>
      <div class="center-box">
        <!-- 常住地 / 护照签发地 -->
        <div class="province-box" :class="{'is-long': countryInfo.area}">
          <div class="filter-label">
            <img class="location-img" src="../../../assets/imgs/product-detail/icon-location-2.png">
            <div class="location-text">{{ ['常住地', '护照签发地', '户籍所在地'][countryInfo.area]}}&nbsp;-&nbsp;<div class="province-code">{{ provinces[provinceCode] }}</div></div>
            <img class="down-triangle blue-triangle" src="../../../assets/imgs/product-detail/icon-down-blue.png">
            <img class="down-triangle gray-triangle" src="../../../assets/imgs/product-detail/icon-down-gray.png">
          </div>
          <div class="filter-box">
            <div class="filter-item" v-for="(value, key) in provinces" :key="key">
              <span
                class="item-text"
                :class="{ 'active': provinceCode === +key }"
                @click="changeProvince(+key)"
              >{{ value }}</span>
            </div>
          </div>
        </div>
      </div>
      

      <div class="holiday-box">
        <div class="module-item" v-if="countryInfo.is_display_visa_strategy" @click="onCountryVisaStrategy">
          <img class="icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/icon-visa-strategy.png" alt="">
          <div class="item-name">办签攻略</div>
        </div> 
        <div class="module-item" @click="showEmbassyHoliday = true">
          <img class="icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/country/icon-embassy-holiday.png" alt="">
          <div class="item-name">使馆放假日历</div>
        </div> 

      </div>
    </div>
    <country-filter
      :country-info="countryInfo"
      :product-list="productList"
      :visa-type.sync="innerVisaType"
      :entry-count-type.sync="innerEntryCountType"
    ></country-filter>
  </div>
  <!-- 使馆放假日历弹窗 -->
  <embassy-holiday-view
    v-model="showEmbassyHoliday"
    class="embassy-holiday"
    :holiday-date-arr="holidayArr"
  ></embassy-holiday-view>
</div>

</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import pcdService from '../../../services/pcd-service';
import utils from '../../../libs/utils';
import embassyHolidayView from './embassy-holiday-view';
import CountryTopCountryInfo from './country-top-country-info.vue';
import CountryFilter from './country-filter.vue';

export default {
  name: '',
  components: {
    embassyHolidayView,
    CountryTopCountryInfo,
    CountryFilter,
  },
  props: {
    productList: Array,
    holidayArr: Array,
    countryInfo: Object,
    provinceCode: Number,
    visaType: String,
    entryCountType: Number,
    isDisplayVisaStrategy: Boolean,
  },
  data() {
    return {
      provinces: {},
      showEmbassyHoliday: false,
      beforeLength: 5,
    };
  },
  computed: {
    innerEntryCountType: {
      get() {
        return this.entryCountType;
      },
      set(value) {
        return this.$emit('update:entryCountType', value);
      },
    },
    innerVisaType: {
      get() {
        return this.visaType;
      },
      set(value) {
        return this.$emit('update:visaType', value);
      },
    },
  },
  created() {
    this.getPcdsAndProvinces();
  },
  methods: {
    initBeforeLength() {},

    getPcdsAndProvinces() {
      return new Promise((resolve, reject) => {
        pcdService.getPcd().then((pcds) => {
          this.provinces = utils.extend({}, pcds[86]);
          resolve({ provinces: this.provinces, pcds });
        }).catch(reject);
      });
    },

    changeProvince(provinceCodeNum) {
      if (this.provinceCode === provinceCodeNum) return;
      sensorsdata.track('Screening_Provinces', {
        country: this.countryInfo.country,
        province: provinceCodeNum,
      });
      this.$emit('update:provinceCode', provinceCodeNum);
    },
    onCountryVisaStrategy() {
      this.$router.push({ name: 'CountryVisaStrategy', params: { id: this.countryInfo.visa_country_id } });
    },
  },
};
</script>

<style scoped lang="less">
.country-top{
  position: fixed;
  top: 84px;
  z-index: 10;
  width: 1120px;
}
.country-info{
  display: flex;
  align-items: center;
  height: 82px;
  background: #FFFFFF;
  border-bottom: 1px solid rgba(0, 0, 0, .06);
  border-radius: 2px;
  margin-bottom: 12px;
  padding: 12px;
  position: relative;
  z-index: 6;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 14px;
    z-index: -1;
    background: #f7f8fa;
  }
  
  .center-box{
    flex-grow: 1;
    height: 100%;
    padding: 0 12px;
    display: flex;
  }
  .province-box {
    // width: 172px;
    height: 100%;
    position: relative;
    z-index: 10;
    flex-shrink: 0;
    &.is-long{
      width: 200px;
    }

    // &::after{
    //   content: "";
    //   width: 1px;
    //   height: 16px;
    //   background: #E9EEF2;
    //   border-radius: 1px;
    //   position: absolute;
    //   right: 0;
    //   top: 50%;
    //   transform: translateY(-50%);
    // }


    .filter-label {
      height: 100%;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 0 20px 0 20px;
      white-space: nowrap;
      position: relative;
      z-index: 11;
      &::before {
        content: "";
        width: 99%;
        display: none;
        position: absolute;
        left: 0;
        bottom: -5px;
        height: 10px;
        z-index: 2;
        background-color: white;
      }

      .location-img {
        width: 12px;
        height: 15px;
        margin-right: 6px;
      }
      .location-text {
        font-size:14px;
        line-height:14px;
        color:#2F333D;
        .province-code {
          display: inline-flex;
        }
      }
      .down-triangle {
        width: 16px;
        height: 16px;
        margin-left: 2px;
        &.blue-triangle {
          display: none;
        }
      }
    }
    .filter-box {
      display: none;
      flex-wrap: wrap;
      padding: 0 0 20px 30px;
      box-shadow:0px 2px 6px 0px rgba(0,0,0,0.12);
      width: 440px;
      position: absolute;
      left: 0;
      top: 100%;
      background-color: white;
      z-index: 1;
      .filter-item {
        display: flex;
        width: 58px;
        margin-top: 20px;
        .item-text {
          font-size:14px;
          line-height: 14px;
          font-weight:400;
          color:rgba(68,68,68,1);
          cursor: pointer;
          &:hover {
            font-weight:500;
            color:rgba(63,162,245,1);
          }
          &.active {
            font-weight:500;
            color:rgba(63,162,245,1);
          }
        }
      }
    }
    &:hover {
      box-shadow:0px 2px 6px 0px rgba(0,0,0,0.12);
      &::after{
        display: none;
      }
      .filter-label{
        &::before {
          display: flex;
        }
        .location-text {
          color: #3FA2F5;
        }
        .blue-triangle {
          display: flex;
        }
        .gray-triangle {
          display: none;
        }
      }
      .filter-box {
        display: flex;
      }
    }
    &.active{
      .filter-label {
        .blue-triangle {
          display: flex;
        }
        .gray-triangle {
          display: none;
        }
      }
    }
  }

  .holiday-box{
    // border-left: 1px solid #F0F0F0;
    height: 100%;
    flex-shrink: 0;
    padding: 0 20px;
    display: flex;
    align-items: center;
    position: relative;
    &::after {
      content: "";
      width: 1px;
      height: 32px;
      background: #E9EEF2;
      border-radius: 1px;
      position: absolute;
      left: 0;
      top: 50%;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
    }
    .module-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 32px;
      cursor: pointer;
      &:last-child{
        margin-right: 0;
      }
      .icon{
        width: 32px;
        height: 32px;
      }
      .item-name{
        color: #599FFF;
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/country/components/country-top.vue